<template lang="pug">
  v-card.info.lighten-5().pa-5
    p.display-1.font-weight-black Facilities Rental Request Form
    p.title Contact: Tony Lewis, Facilities Manager - (510) 633-6316 ext. 105
    p.title We recommend that you contact our office one to three (1-3) months in advance of your event to check for availability. We prefer that you complete the rental request form below so we can prepare for your concerns or questions in advance.
    v-form(ref="theForm" v-model="valid" 'lazy-validation')
      v-row(justify="center")
        v-col(cols="12")
          .body-1.font-italic
            sup
              v-icon.mdi.mdi-asterisk(x-small color="red" )
            |  Indicates required field
      v-row(justify="center")
        v-col(cols="12" md="6")
          v-text-field(v-model="reqForm.Org",outlined, :rules="reqFormRules.Org")
            template( v-slot:label )
              p.required Organiztion
        v-col(cols="12" md="6")
          v-row(justify="center")
            v-col.py-0(cols="12")
              v-select(v-model="reqForm.EventType",outlined :items="eventTypeList" label="Event Type", :menu-props="{ bottom: true, offsetY: true }", :rules="reqFormRules.EventType")
                template( v-slot:label )
                  p.required Event Type
          v-row(justify="center")
            v-col.py-0(cols="12")
              v-text-field(autofocus v-if="reqForm.EventType=='Other'" v-model="reqForm.OtherType",outlined :items="eventTypeList", :rules="reqFormRules.OtherType")
                template( v-slot:label )
                  p.required Other Event Type
      //-/**
          * Contact Information
          */
      v-row(justify="center")
        v-col.py-0(cols="12")
          .title Request Contact Information 
        v-col(cols="12" md="6")
          v-row(justify="center")
            v-col(cols="12" md="6")
              v-text-field(v-model="reqForm.Contact.firstName",outlined, :rules="reqFormRules.Contact.firstName")
                template( v-slot:label )
                  p.required First Name
            v-col(cols="12" md="6")
              v-text-field(v-model="reqForm.Contact.lastName",outlined, :rules="reqFormRules.Contact.lastName")
                template( v-slot:label )
                  p.required Last Name
        v-col(cols="12" md="6")
          v-row(justify="center")
            v-col(cols="12" md="6")
              v-text-field(v-model="reqForm.Contact.email",outlined, :rules="reqFormRules.Contact.email")
                template( v-slot:label )
                  p.required Email
            v-col(cols="12" md="6")
              v-text-field(v-model="reqForm.Contact.phone",outlined, :rules="reqFormRules.Contact.phone")
                template( v-slot:label )
                  p.required Phone
      //-/**
          * Event Date & Time Pickers
          */
      v-row(justify="center")
        v-col.py-0(cols="12")
          .title Request Date & Time
        v-col(cols="12" md="6" align="center")
          v-dialog(ref='dialog' v-model="modal", :return-value.sync='reqForm.EventDate' persistent width='290px')
            template(v-slot:activator="{ on }")
              v-text-field(outlined v-model="reqForm.EventDate" 'prepend-inner-icon'='mdi-calendar' readonly v-on='on' :rules="reqFormRules.EventDate")
                template( v-slot:label )
                  p.required Select The Event Date
            v-date-picker(v-model="reqForm.EventDate" width="290")
              v-spacer
              v-btn(text color='primary' @click="modal = false") Cancel
              v-btn(text color='primary' @click="$refs.dialog.save(reqForm.EventDate)") OK
        v-col(cols="12" md="6")
          v-row(justify="center" no-gutters)
            v-col.timePicker(cols="6" align="start")
              v-dialog( ref='dialog1', v-model='modal2', :return-value.sync='reqForm.StartTime', persistent='', width='290px' style="position:absolute; left:100px; ")
                template(v-slot:activator='{ on }')
                  v-text-field(outlined v-model="reqForm.StartTime", 'prepend-inner-icon'='mdi-clock', readonly='', v-on='on' @click="reqForm.StartTime=''" :rules="reqFormRules.StartTime")
                    template( v-slot:label )
                      p.required Select A Start Time
                v-time-picker(v-if='modal2', v-model='reqForm.StartTime',ampm="true", full-width, :ampm-in-title="true")
                  v-spacer
                  v-btn(text='', color='primary', @click="modal2 = false") Cancel
                  v-btn(text='', color='primary', @click="saveTime('start',reqForm.StartTime)") OK
            v-col.timePicker(cols="6" align="end")
              v-dialog.dEnd(ref='dialog2', v-model='modal3', :return-value.sync='reqForm.EndTime', persistent='', width='290px')
                template(v-slot:activator='{ on }')
                  v-text-field(outlined v-model="reqForm.EndTime", 'prepend-inner-icon'='mdi-clock-check', readonly='', v-on='on' @click="reqForm.EndTime=''" :rules="reqFormRules.EndTime")
                    template( v-slot:label )
                      p.required Select An End Time
                v-time-picker(v-if='modal3', v-model='reqForm.EndTime',ampm="true", full-width, :ampm-in-title="true")
                  v-spacer
                  v-btn(text='', color='primary', @click="modal3 = false") Cancel
                  v-btn(text='', color='primary', @click="saveTime('end',reqForm.EndTime)") OK
      //-/**
          * Event Additional Information
          */
      v-row(justify="center")
        v-col(cols="12" md="6")
          v-text-field.notRequired(v-model='reqForm.EventName',outlined, :rules="reqFormRules.EventName")
            template( v-slot:label )
              p.notRequired Name of Event
        v-col(cols="12" md="6")
          v-textarea(v-model="reqForm.EventPurpose" rows="1"  'auto-grow'  'outlined' counter="250", :rules="reqFormRules.EventPurpose")
            template( v-slot:label )
              p.required Event Purpose 
      v-row(justify="center")
        v-col(cols="12" md="4")
          v-row(justify="center")
            v-col(cols="12")
              v-select(v-model="reqForm.GuestNumber",outlined :items="guestNumList", :menu-props="{ bottom: true, offsetY: true }"  :rules="reqFormRules.GuestNumber")
                template( v-slot:label )
                  p.required How many guests?
            v-col(cols="12")
              .title.required Any Additional Needs?
              v-checkbox.checkBox.ma-0(v-model='reqForm.AddedNeeds' label='None' value='None', :rules="reqFormRules.AddedNeeds" 'hide-details')
              v-checkbox.checkBox.ma-0(v-model='reqForm.AddedNeeds' label='Hospitality (Food Service)' value='Hospitality', :rules="reqFormRules.AddedNeeds" 'hide-details')
              v-checkbox.checkBox.ma-0(v-model='reqForm.AddedNeeds' label='Kitchen' value='Kitchen', :rules="reqFormRules.AddedNeeds" 'hide-details')
              v-checkbox.checkBox.ma-0(v-model='reqForm.AddedNeeds' label='Projector' value='Projector', :rules="reqFormRules.AddedNeeds" 'hide-details')
              v-checkbox.checkBox.ma-0(v-model='reqForm.AddedNeeds' label='Sound' value='Sound', :rules="reqFormRules.AddedNeeds" 'hide-details')
              v-checkbox.checkBox.ma-0(v-model='reqForm.AddedNeeds' label='Other' value='Other', :rules="reqFormRules.AddedNeeds")
              v-row(justify="center")
                v-col.py-0(cols="12")
                  v-text-field(autofocus v-if="reqForm.AddedNeeds.includes('Other')" v-model="reqForm.OtherAddedNeeds",outlined, :rules="reqFormRules.OtherAddedNeeds")
                    template( v-slot:label )
                      p.required Other Additional Need
        v-col(cols="12" md="8")
          v-row(justify="center")
            v-col.mr-2(cols="12" md="4" align="center")
              v-select(v-model="reqForm.RoomNumber",outlined :items="numberOfRmList", :menu-props="{ bottom: true, offsetY: true }" :rules="reqFormRules.RoomNumber")
                template( v-slot:label )
                  p.required How many rooms?
            v-col(cols="12" md="7" align="start")
              .title.required Which rooms will you need?
              v-checkbox.checkBox(v-model='reqForm.Rooms' label='Dining Hall (75-100)' value='Dining Hall', :rules="reqFormRules.Rooms" 'hide-details')
              v-checkbox.checkBox(v-model='reqForm.Rooms' label='Auditorium (200)' value='Auditorium', :rules="reqFormRules.Rooms" 'hide-details')
              v-checkbox.checkBox(v-model='reqForm.Rooms' label='Room 123 (Large Meeting Rm [30-40])' value='Room 123', :rules="reqFormRules.Rooms" 'hide-details')
              v-checkbox.checkBox(v-model='reqForm.Rooms' label='Room 113  (Split Meeting Rm [30-40])' value='Room 113', :rules="reqFormRules.Rooms" 'hide-details')
              v-checkbox.checkBox(v-model='reqForm.Rooms' label='Room 115  (Meeting Room [20-30])' value='Room 115', :rules="reqFormRules.Rooms" 'hide-details')
              v-checkbox.checkBox(v-model='reqForm.Rooms' label='Room 117  (Small Conference Rm [10-20])' value='Room 117', :rules="reqFormRules.Rooms")
      v-row(justify="center")
        v-col(cols="12")     
          v-textarea(v-model="reqForm.Comments" rows="2"  'auto-grow'  outlined counter="500")
            template( v-slot:label )
              p.notRequired Comments (Additional Details)
    v-card-actions
      v-spacer
      v-btn(@click="onReset" color="info", light) Cancel
      v-btn(@click="onSubmitRequest" color="secondary", :disabled="!valid") Submit Request
      
</template>

<script>
import { sendEmail, regexPhone } from '../../plugins/mailer';
const initReqForm = {
  reqDate: new Date(),
  Org: '',
  EventType: '',
  OtherType: '',
  Contact: {
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  },
  // EventDate: new Date().toISOString().substr(0, 10),
  EventDate: '',
  StartTime: '',
  EndTime: '',
  EventName: '',
  EventPurpose: '',
  GuestNumber: '',
  AddedNeeds: [],
  OtherAddedNeeds: '',
  RoomNumber: '',
  Rooms: [],
  Comments: ''
};
export default {
  created() {
    console.log('valid', this.valid);
  },
  data() {
    return {
      valid: null,
      modal: false,
      modal2: false,
      modal3: false,
      // form data models
      reqForm: Object.assign({}, initReqForm),
      reqFormRules: {
        Org: [v => !!v || 'An Organization is required'],
        EventType: [v => !!v || 'An Event Type is required'],
        OtherType: [
          v =>
            !!v ||
            'An "Other" Event Type is required or select a suggested Event Type'
        ],
        Contact: {
          firstName: [
            v => !!v || 'A First Name is required',
            v =>
              (v && v.length >= 2) || 'First Name must be at least 2 characters'
          ],
          lastName: [
            v => !!v || 'A Last Name is required',
            v =>
              (v && v.length >= 2) || 'Last Name must be at least 2 characters'
          ],
          email: [
            v => !!v || 'An Email is required',
            v => {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(v) || 'The E-Mail must be valid.';
            }
          ],
          phone: [v => !!v || 'A Phone Number is required']
        },
        EventDate: [v => !!v || 'An Event Date is required'],
        StartTime: [v => !!v || 'An Event Start Time is required'],
        EndTime: [v => !!v || 'An Event End Time is required'],
        EventPurpose: [
          v => !!v || 'An Event End Time is required',
          v =>
            (v && v.length <= 250) ||
            'The Event Purpose must be no more than 250 characters'
        ],
        GuestNumber: [v => !!v || 'The Number of Guest is required.'],
        AddedNeeds: [
          v =>
            (v && v.length >= 1) ||
            `Select at least one Additional Need. "None", if no need`
        ],
        OtherAddedNeeds: [
          v => !!v || 'Any Other Additional Needs is required.'
        ],
        RoomNumber: [v => !!v || 'The Number of Rooms is required.'],
        Rooms: [
          v => (v && v.length >= 1) || 'Select at least one Room Needed.'
        ],
        Comments: [
          v =>
            v.length > 500 ||
            'The Event Purpose must be no more than 500 characters'
        ]
      },
      // Form Data for Select Lists
      guestNumList: [
        '10-25 guests',
        '25-50 guests',
        '50-100 guests',
        '100-200 guests',
        '200+ guests'
      ],
      numberOfRmList: ['1', '2', '3', '4 or more'],
      eventTypeList: ['Conference', 'Party', 'Meeting', 'Office Space', 'Other']
      // Form Data end
    };
  },
  methods: {
    saveTime(refTime, time) {
      let theArray = time.split(':');
      let theHour = theArray[0];
      let pHour = parseInt(theHour, 10);
      let ampmHour;
      if (pHour == 0) {
        // ampmHour = '12:' + theArray[1];
        ampmHour = '12:' + theArray[1] + ' AM';
      } else if (pHour < 12) {
        // ampmHour = pHour.toString() + ':' + theArray[1];
        ampmHour = pHour.toString() + ':' + theArray[1] + ' AM';
      } else if (pHour > 12) {
        // ampmHour = pHour.toString() - 12 + ':' + theArray[1];
        ampmHour = pHour.toString() - 12 + ':' + theArray[1] + ' PM';
      } else {
        // ampmHour = '12:' + theArray[1];
        ampmHour = '12:' + theArray[1] + ' PM';
      }
      console.log('saveTime -> theHour', ampmHour);
      if (refTime == 'start') {
        this.reqForm.StartTime = ampmHour;
        this.$refs.dialog1.save(this.reqForm.StartTime);
        this.modal2 = false;
      } else {
        this.reqForm.EndTime = ampmHour;
        this.$refs.dialog2.save(this.reqForm.EndTime);
        this.modal3 = false;
      }
    },
    // onValidate() {
    //   this.valid = this.$refs.theForm.validate();
    //   console.log('onSubmitRequest -> this.valid', this.valid);
    // },
    onReset() {
      this.$refs.theForm.reset();
    },
    onSubmitRequest() {
      this.valid = this.$refs.theForm.validate();
      console.log('onSubmitRequest -> this.valid', this.valid);
      // this.onValidate();
      if (this.valid) {
        const info = this.reqForm;
        const to = 'bpj101@dameagnesproductions.com';
        const subj = 'A New Site Rental Request';
        let body = `
        <h2>Site Rental Request Information</h2>
        <ul>
          <li>Organization: <strong>${info.Org}</strong></li>
          <li>Event Type: <strong>${info.EventType}</strong></li>
          <h3>Contact Information</h3>
          <li><strong>${info.Contact.firstName}  ${info.Contact.lastName}</strong></li>
          <li>Email: <strong>${info.Contact.email}</strong></li>
          <li>Phone: <strong>${info.Contact.phone}</strong></li>
          <h3>Event Detailed Information</h3>
          <li>Event Date: <strong>${info.EventDate}</strong></li>
          <li>Start Time: <strong>${info.StartTime}</strong></li>
          <li>End Time: <strong>${info.EndTime}</strong></li>
          <li>Event Name: <strong>${info.EventName}</strong></li>
          <li>Event Purpose: <strong>${info.EventPurpose}</strong></li>
          <li>Guest Number: <strong>${info.GuestNumber}</strong></li>
          <li>Added Needs:</li>
          <ul>
      `;
        info.AddedNeeds.forEach(
          need => (body += `<li><strong>${need}</strong></li>`)
        );
        body += `
          </ul>
          <li>Number Of Rooms: <strong>${info.RoomNumber}</strong></li>
          <li>Specific Rooms:</li>
          <ul>
      `;
        info.Rooms.forEach(
          room => (body += `<li><strong>${room}</strong></li>`)
        );
        body += `
          </ul>
        </ul>
        <h3>Comments (Additional Details)</h3>
        <p>${info.Comments}</p>
      `;
        console.log('body', body);
        /**
         * function for smtp.js plugin
         */
        sendEmail(to, subj, body);
      } else {
        alert('Please complet all required information in Event Request Form');
        console.log('The form is valid', this.valid);
      }

      // console.log(process.env.VUE_APP_UNAME, process.env.VUE_APP_PWORD);
      // Form Data must be mailed to Facilities Manager: Tony Lewis

      /**
       * Code for node server
       */
      // const options = {
      //   headers: { 'access-control-allow-origin': '*' }
      // };
      // let formInfo = {
      //   name: 'Paul Julian',
      //   company: 'Dapified',
      //   phone: '6464173830',
      //   message: 'This is a big Test'
      // };
      // axios
      //   .post('http://localhost:3000/send', formInfo, options)
      //   .then(res => {
      //     console.log('Response ', res);
      //   })
      //   .catch(error => {
      //     console.log(error.response);
      //   });
      // console.log('onSubmitForm -> reqForm', this.reqForm);
      // this.reqForm = Object.assign({}, initReqForm);
    },
    onCancelRequest() {
      this.reqForm = Object.assign({}, initReqForm);
    }
  }
};
</script>

<style lang="stylus" scoped>
.v-dialog.dStart
  position absolute
  top 10px
  left 100px

.required
  font-size 13px

.notRequired
  font-size 13px

.required::after
  content ' * ' !important
  color red

.checkBox
  height 28px !important
  font-size 14px
</style>
